import * as React from "react";
import { getEnterpriseGroupSyncPlugin } from "util/AuthenticationService";
import ServerConfigSection from "../BackendConfigDetails/ServerConfigSection";
import UserSyncSection from "../BackendConfigDetails/UserSyncSection";
import GroupSyncSection from "../BackendConfigDetails/GroupSyncSection";
const BackendConfigDetails = ({ authenticationBackend, roles }) => {
  var _a, _b;
  const enterpriseGroupSyncPlugin = getEnterpriseGroupSyncPlugin();
  const { excludedFields: groupSyncExcludedFields = {} } = (_b = (_a = enterpriseGroupSyncPlugin == null ? void 0 : enterpriseGroupSyncPlugin.wizardConfig) == null ? void 0 : _a.ldap) != null ? _b : {};
  const excludedFields = { ...groupSyncExcludedFields };
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(ServerConfigSection, { authenticationBackend }), /* @__PURE__ */ React.createElement(UserSyncSection, { authenticationBackend, roles, excludedFields }), /* @__PURE__ */ React.createElement(GroupSyncSection, { authenticationBackend, roles, excludedFields }));
};
export default BackendConfigDetails;
